<template>
  <div class="be-content">
    <div class="main-content container-fluid">
      <div class="row">
        <label class="col-sm-12">Отчетный период:</label>
        <div class="col-md-3">
          <select class="form-control input-sm" v-model="filterPeriod">
            <option v-for="period in reportPeriods" :value="period">
              <span>{{period.name}}</span>
            </option>
          </select>
        </div>
      </div>
      <template v-if="dataReady">
        <div class="row">
          <div class="col-sm-12">
            <h2>
              Статистика подачи данных с {{filterPeriod.date_start | dateFilter("DD.MM")}} по {{filterPeriod.date_end | dateFilter("DD.MM.YYYY")}}г.</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="widget">
              <div class="widget-head">
                <span class="title">Количество операторов сбора</span>
              </div>
              <div class="widget-chart-container">
                <h3><i class="icon mdi mdi-pin"></i> {{stats.operators_count}}</h3>
              </div>
            </div>
            <div class="widget">
              <div class="widget-head">
                <span class="title">Кол-во плательщиков</span>
              </div>
              <div class="widget-chart-container">
                <h3><i class="icon mdi mdi-accounts-list"></i> {{stats.guest_visit_count}}</h3>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="widget">
              <div class="widget-head">
                <span class="title">Статистика отчетов - всего {{stats.reports_count}}шт.</span>
              </div>
              <div class="widget-chart-container">
                <pie-chart :data="[stats.reports_count-stats.reports_submitted_count, stats.reports_submitted_count]"
                           :labels="['Не сдано: ' + Number(stats.reports_count-stats.reports_submitted_count), 'Сдано: '+stats.reports_submitted_count]"
                           :showLegend="false" v-if="stats" :width="400" :height="200"></pie-chart>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="widget">
              <div class="widget-head">
                <span class="title">Размещенных лиц (всего): {{stats.guest_visit_count}}</span>
                <span class="title"><li>оплативших сбор: {{stats.guest_visit_paid_count}} ({{guestsPaidPercentage}}%)</li></span>
                <span class="title"><li>отказавшихся от оплаты: {{stats.guest_visit_refusal_count}} ({{guestsRefusalPercentage}}%)</li></span>
                <span class="title"><li>освобожденных от оплаты (льготники): {{stats.guest_visit_privilege_count}} ({{guestsPrivilegePercentage}}%)</li></span>
                <pie-chart
                  :data="[stats.guest_visit_paid_count, stats.guest_visit_refusal_count, stats.guest_visit_privilege_count]"
                  :labels="['Оплативших', 'Отказавшихся', 'Льготников']"
                  :showLegend="false" v-if="stats" :width="400" :height="200"
                  :backgroundColor="['rgb(52, 168, 83)', 'rgb(229,43,80)', 'rgb(121, 185, 248)' ]"></pie-chart>
              </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="widget">
              <div class="widget-head">
                <span class="title">Количество добавленных записей по дням отчетного периода</span>
              </div>
              <div class="widget-chart-container">
                <bar-chart :data="Object.values(stats.records_by_days)" :labels="Object.keys(stats.records_by_days)"
                           :showLegend="false" v-if="stats"></bar-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="widget">
              <div class="widget-head">
                <span class="title">Количество предоставленных отчетов</span>
              </div>
              <div class="widget-chart-container">
                <bar-chart :data="Object.values(stats.reports_submitted_by_days)" :labels="Object.keys(stats.reports_submitted_by_days)"
                           :showLegend="false" v-if="stats"></bar-chart>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="row" v-if="!dataReady">
        <div class="col-lg-12" style="margin-top: 50px">
          <vue-simple-spinner :font-size="20" message="Загрузка данных ..."></vue-simple-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import BarChart from '@/components/charts/BarChart'
  import PieChart from '@/components/charts/PieChart'

  export default {
    name: "LiveStats",
    components: {BarChart, PieChart},
    data: function () {
      return {
        stats: null,
        filterPeriod: null,
        reportPeriods: null,
        dataReady: false
      }
    },
    computed:{
      guestsPaidPercentage () {
        return Number.parseFloat(this.stats.guest_visit_paid_count/this.stats.guest_visit_count*100).toFixed(2)
      },
      guestsRefusalPercentage () {
        return Number.parseFloat(this.stats.guest_visit_refusal_count/this.stats.guest_visit_count*100).toFixed(2)
      },
      guestsPrivilegePercentage () {
        return Number.parseFloat(100 - this.guestsPaidPercentage - this.guestsRefusalPercentage).toFixed(2)
      },


    },
    created () {
      this.getCurrentReportPeriod()
      this.getReportsPeriods()
    },
    methods: {
      getCurrentReportPeriod () {
        this.axios.get('/api/reports/current')
          .then((response) => {
            if (response.status === 200) {
              this.filterPeriod = response.data
            }
          })
      },
      getReportsPeriods () {
        this.axios.get('/api/reports/periods')
          .then((response) => {
            if (response.status === 200) {
              this.reportPeriods = response.data
            }
          })
      },
      getStats () {
        this.dataReady = false
        this.axios.get('/api/stats/live', {
          params: {
            'date_start': this.filterPeriod.date_start,
            'date_end': this.filterPeriod.date_end
          }
        }).then((response) => {
          if (response.status === 200) {
            this.stats = response.data
            this.dataReady = true
          }
        })
      }
    },
    watch: {
      filterPeriod () {
        this.getStats()
      }
    }
  }
</script>

<style scoped>
  tr.warn {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/LiveStats.vue